module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padding-md"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.searchForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "应用名称"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.searchForm.name),
      callback: function($$v) {
        _vm.$set(_vm.searchForm, "name", $$v)
      },
      expression: "searchForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "native-type": "submit"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        _vm.loadData($event)
      }
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        _vm.showDialog(false)
      }
    }
  }, [_vm._v("添加")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.games,
      "stripe": true,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "width": "80",
      "label": "ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "游戏名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "iconName",
      "label": "图标名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "appKey",
      "label": "游戏标识"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "appSecret",
      "label": "游戏签名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "redirectUrl",
      "label": "转发地址"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "noticeUrl",
      "label": "通知地址"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "viewStatus",
      "label": "横竖屏"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": "操作",
      "min-width": "160",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.showDialog(scope.row)
            }
          }
        }, [_vm._v("修改")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              _vm.deleteGame(scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    staticClass: "update",
    attrs: {
      "el-dialog": "",
      "title": _vm.title,
      "visible": _vm.showEditorDialog,
      "before-close": _vm.handleBeforeCloseDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.showEditorDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "formData",
    attrs: {
      "model": _vm.formData,
      "label-width": "80px",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    staticClass: "form-item__full-width",
    attrs: {
      "label": "图标名称",
      "prop": "iconName",
      "placeholder": "请输入游戏名称"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formData.iconName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "iconName", $$v)
      },
      expression: "formData.iconName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item__full-width",
    attrs: {
      "prop": "name",
      "label": "游戏名称",
      "placeholder": "请输入游戏名称"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "formData.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item__full-width",
    attrs: {
      "prop": "appKey",
      "label": "游戏标识",
      "placeholder": "请输入游戏标识"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "disabled": !!_vm.formData.id
    },
    model: {
      value: (_vm.formData.appKey),
      callback: function($$v) {
        _vm.$set(_vm.formData, "appKey", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "formData.appKey"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item__full-width",
    attrs: {
      "prop": "redirectUrl",
      "label": "转发地址",
      "placeholder": "请输入游戏转发地址"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.formData.redirectUrl),
      callback: function($$v) {
        _vm.$set(_vm.formData, "redirectUrl", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "formData.redirectUrl"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item__full-width",
    attrs: {
      "prop": "noticeUrl",
      "label": "通知地址",
      "placeholder": "请输入游戏通知地址"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.formData.noticeUrl),
      callback: function($$v) {
        _vm.$set(_vm.formData, "noticeUrl", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "formData.noticeUrl"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item__full-width",
    attrs: {
      "prop": "viewStatus",
      "label": "横竖屏",
      "placeholder": "请输入横竖屏"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text"
    },
    model: {
      value: (_vm.formData.viewStatus),
      callback: function($$v) {
        _vm.$set(_vm.formData, "viewStatus", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "formData.viewStatus"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "native-type": "submit"
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        _vm.handleSubmit('formData')
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.closeDialog
    }
  }, [_vm._v("返回")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4884b0cf","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/admin/games.vue
// module id = V2zn
// module chunks = 3